import Overlay from 'common/module/ui/Overlay';
import { addClass, removeClass } from 'common/tools/dom/classes';
import { on } from 'common/tools/dom/events';

const SHORTS_CARD_SELECTOR = '.video-card-shorts';
const PLAYER_CLASSNAME = 'shorts-player';
const WRAPPER_CLASSNAME = 'shorts-overlay';

const OVERLAY_CLOSE_CLASSNAME = 'js-trigger-overlay-close';

const BODY_OPEN_CLASSNAME = 'shorts-overlay-open';

const CLOSE_ICON = 'close1';

const EMBED_PARAMS = 'autoplay=1&controls=0&rel=0&playsinline=1';

const IFRAME_ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

function createPlayer(videoId: string, title: string): HTMLElement {
  const wrapper = document.createElement('div');
  const player = document.createElement('iframe');
  const closeButton = document.createElement('div');

  player.className = PLAYER_CLASSNAME;
  player.title = title;
  player.allow = IFRAME_ALLOW;
  player.allowFullscreen = true;
  player.src = `https://www.youtube.com/embed/${videoId}?${EMBED_PARAMS}`;

  closeButton.className = `shorts-overlay-close ui-icons ${OVERLAY_CLOSE_CLASSNAME}`;
  closeButton.textContent = CLOSE_ICON;

  wrapper.className = `${WRAPPER_CLASSNAME} ${OVERLAY_CLOSE_CLASSNAME}`;
  wrapper.append(player, closeButton);

  on(wrapper, 'click', () => removeClass(document.body, BODY_OPEN_CLASSNAME));

  return wrapper;
}

export default function shortsPlayer(): void {
  const cards = document.querySelectorAll<HTMLElement>(SHORTS_CARD_SELECTOR);

  if (!cards.length) {
    return;
  }

  on(window, 'keydown', (event: Event) => {
    if ((event as KeyboardEvent).key === 'Escape') {
      removeClass(document.body, BODY_OPEN_CLASSNAME);
    }
  });

  cards.forEach(card => {
    const { videoId } = card.dataset;
    const link = card.querySelector('a');

    if (!videoId || !link) {
      return;
    }

    on(link, 'click', (event: Event) => {
      event.preventDefault();

      Overlay.empty();

      Overlay.init(
        createPlayer(videoId, link.textContent?.trim() ?? ''),
        'modal'
      );
      addClass(document.body, BODY_OPEN_CLASSNAME);
    });
  });
}
